<template>
  <confirm-dialog
    v-show="isShow"
    :data="dialogData"
    name="uploadBannerCoverDialog"
    @confirm="handleConfirm"
  >
    <div class="box">
      <div class="row mx-auto">
        <div class="col-12 p-0 mt-4">
          <croppa
            v-model="image"
            :accept="'image/*'"
            :placeholder="''"
            :file-size-limit="upload.MAX_FILE_SIZE_B"
            :width="320"
            :height="200"
            :show-remove-button="false"
            :replace-drop="true"
            :initial-image="initialImage"
            class="upload-box dropzone"
            @file-size-exceed="fileSizeExceed()"
            @file-choose="handleFileChoose"
          >
            <div class="upload-placeholder">
              <img :src="'/static/icons/button-add-cover.svg'" />
              <div>
                เพิ่มรูปภาพ
                <br />
                <br />(คลิก หรือลากไฟล์ลงในกรอบนี้)
              </div>
            </div>
          </croppa>
          <img
            v-if="fileChose && canEdit"
            src="/static/icons/cancel-black.svg"
            class="btn-remove pointer"
            @click="removeFile()"
          />
          <div class="remake">
            {{ "* " + $t("feature.upload.banner_resolution_label") }}
            {{ $t("and") }}
            {{
              `${$t("feature.upload.condition_label")} ${labels.maxFileSize} MB`
            }}
          </div>
        </div>
      </div>
    </div>
  </confirm-dialog>
</template>

<script>
import { UPLOAD } from "@/config/constant"

export default {
  props: {
    coverUrl: {
      type: null,
      default: undefined,
    },
    coverKey: {
      type: null,
      default: undefined,
    },
    canEdit: {
      type: null,
      default: undefined,
    },
    isShow: {
      type: null,
      default: undefined,
    },
    isLoading: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      initialImage: this.coverUrl,
      image: null,
      file: "",
      key: this.coverKey,
      labels: {
        maxFileSize: UPLOAD.MAX_FILE_SIZE_MB,
      },
      fileChose: !!this.coverUrl,
      upload: UPLOAD,
    }
  },
  computed: {
    dialogData() {
      const buttonSubmit = this.isLoading
        ? "กำลังดำเนินการ"
        : "เลือกและตั้งเป็นแบนเนอร์"
      return {
        title: "เลือกภาพปกแบนเนอร์",
        buttonCancel: "ยกเลิก",
        buttonSubmit,
        disableSubmit: this.isLoading,
        disableCancel: this.isLoading,
      }
    },
  },
  methods: {
    handleConfirm(isConfirm) {
      if (!isConfirm) {
        this.$emit("cancel")
        this.removeFile()
        return
      }

      const { file } = this
      this.$emit("confirm", file)
    },
    handleFileChoose(file) {
      this.file = file
      this.fileChose = true
    },
    fileSizeExceed() {
      this.fileChose = false
      this.$message.error(
        `${this.$t("feature.upload.exceed_max_file_size")} ${
          UPLOAD.MAX_FILE_SIZE_MB
        } MB`,
      )
    },
    removeFile() {
      this.fileChose = false
      this.image.remove()
    },
  },
}
</script>

<style lang="scss" scoped>
#upload {
  background-color: rgba(74, 74, 74, 0.5);
}
.upload-box {
  width: 320px;
  height: 200px;
  border: 2px dashed #d8d6d9;

  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: center;
  color: #8c8786;
  object-fit: cover;

  margin: 0 auto;
  position: relative;

  &.overlay {
    position: absolute;
    top: 0;
    left: 0;
  }
}
.upload-placeholder {
  position: absolute;
  pointer-events: none;
}
.upload-box.croppa--has-target .upload-placeholder {
  display: none;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  left: 0;
  width: 360px;
  height: 154px;
  position: absolute;
  cursor: pointer;
  z-index: 99;
}
.btn-remove {
  position: absolute;
  width: 25px;
  height: 25px;
  top: -10px;
  right: -10px;
}
.show-file {
  width: 360px;
  height: 154px;
}
.remake {
  font-size: 11px;
  font-weight: normal;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
  margin-top: 16px;
  text-align: center;
}
</style>
